import { render } from "./FormatList.vue?vue&type=template&id=85ce42c2&scoped=true"
import script from "./FormatList.vue?vue&type=script&lang=js"
export * from "./FormatList.vue?vue&type=script&lang=js"

import "./FormatList.vue?vue&type=style&index=0&id=85ce42c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ce42c2"]])

export default __exports__